<template>
  <div class="footer">
    <div class="f-top">
        <div class="top">
            <div class="top-info">
                <div class="info-group">
                    <h4>网站地图</h4>
                    <ul class="fix">
                        <li @click="$router.push({ path: '/overview', query: { subtitle: 'sysgk' } })"><a href="javascript:;">实验室概况</a></li>
                        <li @click="$router.push({ path: '/alumnus', query: { subtitle: 'sztd' } })"><a href="javascript:;">师资队伍</a></li>
                        <li @click="$router.push({ path: '/dynamic', query: { subtitle: 'sysdt2' } })"><a href="javascript:;">实验室动态</a></li>
                        <li @click="$router.push({ path: '/research', query: { subtitle: 'kxyj' } })"><a href="javascript:;">科学研究</a></li>
                        <!-- <li @click="$router.push({ path: '/platform', query: { subtitle: 'kypt' } })"><a href="javascript:;">成果转化</a></li> -->
                        <li @click="$router.push({ path: '/student', query: { subtitle: 'xsfc' } })"><a href="javascript:;">学生风采</a></li>
                        <li @click="$router.push({ path: '/graduate', query: { subtitle: 'zsxx' } })"><a href="javascript:;">招生信息</a></li>
                    </ul>
                </div>
                <div class="info-group">
                    <h4>联系我们</h4>
                    <p>地址：河北省保定市莲池区永华北大街619号华北电力大学</p>
                    <p>邮编：071003</p>
                    <p>电话：03127522036</p>
                </div>
            </div>

            <div class="img-box">
                <a href="/" class="footer-logo">
                    <img src="@/assets/logowhite.png" alt="" class="logo">
                </a>

            </div>
        </div>
    </div>
    <div class="f-bottom">
        <div class="bottom-inner">
            <span>版权所有 &copy; 杰德实验室</span>
            <!-- <button class="footer-login" @click="$router.push({ path: '/login' })">门户登录</button> -->
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerIndex'
}
</script>

<style lang="less">
.footer{
    height:auto;
    .f-top{
        .top{
            position: relative;
            padding:0 107px;
            .top-info{
                width:782px;
                height:auto;
                margin:0 0 0 240px;
                .info-group{
                    float: left;
                    width: 50%;
                    height:auto;
                    padding-left: 50px;
                    padding-right:20px;
                    position: relative;
                    border-left:1px solid rgba(255, 255, 255, 0.3);
                    h4{
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 20px;
                        margin-bottom: 10px;
                    }
                    .fix{
                        height:auto;
                        li{
                            float: left;
                            width: 25%;
                            height:28px;
                            a{
                                display: inline-block;
                                font-size: 14px;
                                color: rgba(255, 255, 255, 0.874);
                                line-height: 16px;
                                margin-bottom: 4px;
                                &:hover{
                                    color:rgb(255, 255, 255)
                                }
                            }
                        }
                    }
                    p{
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.874);
                        line-height: 16px;
                        margin-bottom: 8px;
                    }
                }
            }
            .footer-logo{
                position: absolute;
                left: 140px;
                top: -4px;
                width: 96px;
                .logo{
                    width:100%;
                    height:100%;
                }
            }
            .ewm{
                position: absolute;
                right: 106px;
                top: 0px;
                width: 70px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .f-bottom{
        background: #0E6BB6;
        text-align: center;
        padding:0 107px;
        .bottom-inner{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 14px;
            min-height: 22px;
        }
        span,
        a{
            font-size: 11px;
            color: rgba(255, 255, 255, 0.6);
            line-height: 20px;
            display: inline-block;
            margin-right: 0;
        }
        .footer-login{
            position: relative;
            border: 0;
            background: transparent;
            color: rgba(255, 255, 255, 0.76);
            font-size: 12px;
            line-height: 20px;
            padding: 0 0 0 14px;
            cursor: pointer;
            transition: transform 0.25s ease, color 0.25s ease;
            &::before{
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                width: 1px;
                height: 12px;
                transform: translateY(-50%);
                background: rgba(255, 255, 255, 0.32);
            }
            &:hover{
                color: #fff;
            }
        }
    }
}
</style>
